export { debounce as default } from 'function-tree/factories'
